// import React, { useCallback, useContext, useEffect, useState } from 'react'
// import { LoginAPI } from '../redux/actions/auth/LoginAction';
// import { showErrorToast, showSuccessToast } from '../helpers/toast';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { AuthContext } from '../context/AuthContext';
// import { toast } from 'react-toastify';
// import { PulseLoader } from 'react-spinners';
// import { loginStateReset } from '../redux/slices/auth/LoginSlice';
// import axios from 'axios';

// const Login = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     // Extract login related state from redux store
//     const { response, loading, error } = useSelector((state) => state.login);


//     // Access authentication context to update auth status after login
//     const { login: contextLogin, isAuthenticated } = useContext(AuthContext);

//     // Local state to hold form input values and UI states
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [validationErrors, setValidationErrors] = useState('');
//     const [passwordShown, setPasswordShown] = useState(false);


//     // Validate form inputs before submission
//     const validateForm = () => {
//         const newErrors = {};

//         // Check if email is empty or invalid format
//         if (!email.trim()) {
//             newErrors.email = 'Email is required';
//         } else if (!/\S+@\S+\.\S+/.test(email)) {
//             newErrors.email = 'Enter a valid email address';
//         }
//         // Check if password is empty
//         if (!password.trim()) {
//             newErrors.password = 'Password is required';
//         }

//         setValidationErrors(newErrors);

//         // Return true if there are no validation errors
//         return Object.keys(newErrors).length === 0;
//     };


//     // Handle form submission for login (memoized to prevent unnecessary re-renders)
//     const handleSubmit = useCallback(async (event) => {
//         event.preventDefault();
//         if (!validateForm()) {
//             return;
//         }
//         try {
//             // Dispatch login API call with email and password
//             dispatch(LoginAPI({ email, password }));
//         } catch (error) {
//             // Show error toast in case of unexpected failure
//             showErrorToast(error);
//         }

//     }, [email, password, dispatch]);

  


//     // Reset login state when component unmounts to clean redux store
//     useEffect(() => {
//         return () => {
//             dispatch(loginStateReset());
//         };
//     }, [dispatch]);

//     useEffect(() => {
//         if (response?.status === true) {
//             contextLogin(response?.data?.token);
//             setEmail('');
//             setPassword('');
//             setValidationErrors('');
//             showSuccessToast(response?.message);
//             dispatch(loginStateReset())
//             navigate('/dashboard')
//         }
//     }, [response, loading, contextLogin, navigate]);


//     // Show toast on login API error
//     useEffect(() => {
//         if (error) {
//             toast.dismiss();
//             showErrorToast(error.data, "error");
//         }
//     }, [error]);



//     // Redirect to home if user is already authenticated
//        useEffect(() => {
//         if (isAuthenticated) {
//             navigate('/dashboard');
//         }
//     }, [isAuthenticated, navigate]);

//     return (
//         <div className="credential_main_wrapper">
//             <div className="credential_content_outer">
//                 <div className="credential_content_wrapper">
//                     {/* Logo Section */}
//                     <div className="credential_logo">
//                         <img src="/assets/images/L1.svg" alt="Logo" />
//                     </div>
//                     {/* Welcome Text Section */}
//                     <div className="credential_content_info">
//                         <h1>Welcome to Yune Admin<br className="d-none d-lg-block" /></h1>
//                         <p className="mb-0 credential_sub_heading">Behind every course is a mum-to-be finding confidence.</p>
//                         <p className="mb-0 credential_sub_heading">Log in to keep Yune’s content accurate, supportive, and full of care.</p>
//                         {/* <p className="mb-0 mt-1">Log in to keep Yune’s content accurate, supportive, and full of care.</p> */}
//                     </div>
//                     {/* Footer Links */}
//                     <div className="credential_footer_block">
//                         {/* <Link to='/terms' className="credential_footer_links">Terms</Link>
//                         <Link to="/privacy" className="credential_footer_links">Contact Us</Link> */}
//                     </div>
//                 </div>
//             </div>
//             <div className="credential_form_wrapper">
//                 <div className="credential_form_card">
//                     <h2>Login</h2>
//                     {/* Login Form */}
//                     <form onSubmit={handleSubmit}>
//                         <div className="form_field_wrapper">
//                             {/* Email Input Field */}
//                             <div className="form_field">
//                                 <label htmlFor="email">Email</label>
//                                 <div className="input_field">
//                                     <input type="email" className="form-control" name="Email" id="email" value={email}
//                                         onKeyDown={(e) => {
//                                             // Prevent space as first character in input
//                                             if (e.key === ' ' && e.currentTarget.value.trim() === '') {
//                                                 e.preventDefault();
//                                             }
//                                         }}
//                                         onChange={(e) => {
//                                             const value = e.target.value;
//                                             setEmail(value);
//                                             // Clear email validation error as user types
//                                             if (validationErrors.email) {
//                                                 setValidationErrors(prev => ({ ...prev, email: false }));
//                                             }
//                                         }}
//                                     />
//                                 </div>
//                                 {/* Display email validation error */}
//                                 {validationErrors.email &&
//                                     (
//                                         <span className={`error ${validationErrors.email ? '' : 'd-none'}`}>{validationErrors.email}</span>
//                                     )
//                                 }
//                             </div>
//                             {/* Password Input Field */}
//                             <div className="form_field">
//                                 <label htmlFor="loginPassword">Password</label>
//                                 <div className="input_field">
//                                     <input type={passwordShown ? "text" : "password"} className="form-control" name="password" id="loginPassword" value={password}
//                                         onChange={(e) => {
//                                             const value = e.target.value;
//                                             // Prevent space as first character
//                                             if (value.length === 1 && value === ' ') return;
//                                             setPassword(value);
//                                             // Clear password validation error as user types
//                                             if (validationErrors.password) {
//                                                 setValidationErrors(prev => ({ ...prev, password: false }));
//                                             }
//                                         }}
//                                     />
//                                     {/* Toggle password visibility */}
//                                     <span className="eye-icon" onClick={() => setPasswordShown(prev => !prev)}>
//                                         <i className={`fa-regular ${passwordShown ? "fa-eye" : "fa-eye-slash"}`} id="eyeLogin" />
//                                     </span>
//                                 </div>
//                                 {/* Display password validation error */}
//                                 {validationErrors.password && (
//                                     <span className={`error ${validationErrors.password ? '' : 'd-none'}`}>{validationErrors.password}</span>
//                                 )}
//                             </div>
//                         </div>
//                         {/* {Forgot password section} */}
//                         <div className="forgot_action_block d-flex justify-content-end align-items-center flex-wrap gap-2 mt-1">
//                             <div className="forgot-psw">
//                                 <Link to='/send-otp' className="forgotpsw-link fw-medium text-primary text-decoration-none">Forgot password?</Link>
//                             </div>
//                         </div>
//                         {/* login button  */}
//                         <div className="form-btn-blk">
//                             <button className="form-btn w-100 fw-medium text-white text-capitalize">
//                                 {loading ? <PulseLoader color="#ffffff" /> : 'Login'}
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//             </div >
//         </div >

//     )
// }

// export default Login








import React, { useCallback, useContext, useEffect, useState } from 'react'
import { LoginAPI } from '../redux/actions/auth/LoginAction';
import { VerifyAdminLoginOtpAPI } from '../redux/actions/auth/VerifyAdminLoginOtpAction';
import { ResendAdminLoginOtpAPI } from '../redux/actions/auth/ResendAdminLoginOtpAction';
import { verifyAdminLoginOtpStateReset } from '../redux/slices/auth/VerifyAdminLoginOtpSlice';
import { resendAdminLoginOtpStateReset } from '../redux/slices/auth/ResendAdminLoginOtpSlice';
import { showErrorToast, showSuccessToast } from '../helpers/toast';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { ClipLoader, PulseLoader } from 'react-spinners';
import { loginStateReset } from '../redux/slices/auth/LoginSlice';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { response: loginResponse, loading: loginLoading, error: loginError } = useSelector((state) => state.login);
    const { response: otpResponse, loading: otpLoading, error: otpError } = useSelector((state) => state.verifyAdminLoginOtp);
    const { response: resendResponse, loading: resendLoading, error: resendError } = useSelector((state) => state.resendAdminLoginOtp);

    const { login: contextLogin, isAuthenticated } = useContext(AuthContext);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [step, setStep] = useState('login'); // 'login' | 'otp'
    const [validationErrors, setValidationErrors] = useState({});
    const [passwordShown, setPasswordShown] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    // Timer for resend OTP
    useEffect(() => {
        if (step !== 'otp') return;
        setCanResend(false);
        setTimer(60);
        const interval = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) { clearInterval(interval); setCanResend(true); return 0; }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [step, resendResponse]);

    const validateForm = () => {
        const newErrors = {};
        if (!email.trim()) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Enter a valid email address';
        if (!password.trim()) newErrors.password = 'Password is required';
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Step 1: Login → triggers OTP send
    const handleLoginSubmit = useCallback(async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        dispatch(LoginAPI({ email, password }));
    }, [email, password, dispatch]);

    // Step 2: Verify OTP
    const handleOtpSubmit = (e) => {
        e.preventDefault();
        if (!otp.trim()) return showErrorToast("Please enter the OTP");
        dispatch(VerifyAdminLoginOtpAPI({ email, otp: Number(otp) }));
    };

    // Resend OTP
    const handleResendOtp = () => {
        if (!canResend) return;
        dispatch(ResendAdminLoginOtpAPI({ email }));
    };

    // Login success → move to OTP step
    useEffect(() => {
        if (loginResponse?.status === true) {
            showSuccessToast(loginResponse?.message);
            dispatch(loginStateReset());
            setStep('otp'); // go to OTP step
        }
    }, [loginResponse]);

    // Login error
    useEffect(() => {
        if (loginError) {
            toast.dismiss();
            showErrorToast(loginError?.data);
        }
    }, [loginError]);

    // OTP verify success → complete login
    useEffect(() => {
        if (otpResponse?.status === true) {
            contextLogin(otpResponse?.data?.token);
            showSuccessToast(otpResponse?.message);
            dispatch(verifyAdminLoginOtpStateReset());
            navigate('/dashboard');
        }
    }, [otpResponse]);

    // OTP verify error
    useEffect(() => {
        if (otpError) {
            showErrorToast(otpError?.data);
            setOtp('');
            dispatch(verifyAdminLoginOtpStateReset());
        }
    }, [otpError]);

    // Resend success
    useEffect(() => {
        if (resendResponse) {
            showSuccessToast('OTP resent successfully');
            dispatch(resendAdminLoginOtpStateReset());
        }
    }, [resendResponse]);

    // Resend error
    useEffect(() => {
        if (resendError) {
            showErrorToast(resendError?.data);
            dispatch(resendAdminLoginOtpStateReset());
        }
    }, [resendError]);

    // Already logged in
    useEffect(() => {
        if (isAuthenticated) navigate('/dashboard');
    }, [isAuthenticated, navigate]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            dispatch(loginStateReset());
            dispatch(verifyAdminLoginOtpStateReset());
            dispatch(resendAdminLoginOtpStateReset());
        };
    }, [dispatch]);

    return (
        <div className="credential_main_wrapper">
            <div className="credential_content_outer">
                <div className="credential_content_wrapper">
                    <div className="credential_logo">
                        <img src="/assets/images/L1.svg" alt="Logo" />
                    </div>
                    <div className="credential_content_info">
                        <h1>Welcome to Yune Admin<br className="d-none d-lg-block" /></h1>
                        <p className="mb-0 credential_sub_heading">Behind every course is a mum-to-be finding confidence.</p>
                        <p className="mb-0 credential_sub_heading">Log in to keep Yune's content accurate, supportive, and full of care.</p>
                    </div>
                </div>
            </div>

            <div className="credential_form_wrapper">
                <div className="credential_form_card">

                    {step === 'login' ? (
                        <>
                            <h2>Login</h2>
                            <form onSubmit={handleLoginSubmit}>
                                <div className="form_field_wrapper">
                                    <div className="form_field">
                                        <label htmlFor="email">Email</label>
                                        <div className="input_field">
                                            <input type="email" className="form-control" id="email" value={email}
                                                onKeyDown={(e) => {
                                                    if (e.key === ' ' && e.currentTarget.value.trim() === '') e.preventDefault();
                                                }}
                                                onChange={(e) => {
                                                    setEmail(e.target.value);
                                                    if (validationErrors.email) setValidationErrors(p => ({ ...p, email: false }));
                                                }}
                                            />
                                        </div>
                                        {validationErrors.email && <span className="error">{validationErrors.email}</span>}
                                    </div>
                                    <div className="form_field">
                                        <label htmlFor="loginPassword">Password</label>
                                        <div className="input_field">
                                            <input type={passwordShown ? "text" : "password"} className="form-control"
                                                id="loginPassword" value={password}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value.length === 1 && value === ' ') return;
                                                    setPassword(value);
                                                    if (validationErrors.password) setValidationErrors(p => ({ ...p, password: false }));
                                                }}
                                            />
                                            <span className="eye-icon" onClick={() => setPasswordShown(p => !p)}>
                                                <i className={`fa-regular ${passwordShown ? "fa-eye" : "fa-eye-slash"}`} />
                                            </span>
                                        </div>
                                        {validationErrors.password && <span className="error">{validationErrors.password}</span>}
                                    </div>
                                </div>
                                <div className="forgot_action_block d-flex justify-content-end align-items-center flex-wrap gap-2 mt-1">
                                    <Link to='/send-otp' className="forgotpsw-link fw-medium text-primary text-decoration-none">Forgot password?</Link>
                                </div>
                                <div className="form-btn-blk">
                                    <button className="form-btn w-100 fw-medium text-white text-capitalize">
                                        {loginLoading ? <PulseLoader color="#ffffff" /> : 'Login'}
                                    </button>
                                </div>
                            </form>
                        </>
                    ) : (
                        <>
                            <h2>Enter OTP</h2>
                            {email && <p>{`OTP sent to this email: ${email}`}</p>}
                            <form onSubmit={handleOtpSubmit}>
                                <div className="form_field_wrapper">
                                    <div className="form_field">
                                        <div className="input_field">
                                            <input type="text" className="form-control" placeholder="Enter OTP"
                                                value={otp} inputMode="numeric" pattern="[0-9]*"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) setOtp(value);
                                                }}
                                            />
                                        </div>
                                        {/* Resend timer — same as your VerifyOtp.jsx */}
                                        {timer > 0 ? (
                                            <p className="text-end mt-2">Resend OTP in: {timer} sec</p>
                                        ) : (
                                            <div className="hstack justify-content-end mt-2">
                                                <button type="button"
                                                    className="border-0 p-0 bg-white text-black fs-12 ms-auto"
                                                    disabled={!canResend || resendLoading}
                                                    onClick={handleResendOtp}
                                                >
                                                    {resendLoading ? <ClipLoader color="#000000" size={24} /> : 'Resend OTP'}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="form-btn-blk">
                                    <button className="form-btn w-100 fw-medium text-white text-capitalize">
                                        {otpLoading ? <PulseLoader color="#ffffff" /> : 'Verify'}
                                    </button>
                                </div>
                                <div className="text-center mt-2">
                                    <span className="forgotpsw-link fw-medium text-primary"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => { setStep('login'); setOtp(''); }}>
                                        ← Back to Login
                                    </span>
                                </div>
                            </form>
                        </>
                    )}

                </div>
            </div>
        </div>
    );
};

export default Login;